<template>

  <div class="FaceDevice-manage">
    <el-button type="success" @click="fnAddDeivce()">添加设备</el-button>
    <el-table :key="tableKey" :data="lists" border stripe>
      <el-table-column label="设备编号" prop="value" align="center" width="100px" />
      <el-table-column label="状态" align="left">
        <template slot-scope="{row}">
          <el-tag v-if="row.online == 1" type="success">在线</el-tag>
          <el-tag v-if="row.online == 0" type="default">离线</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark" align="left"   />
      <el-table-column label="操作" align="left">
        <template slot-scope="{row}">
          <el-tooltip class="item" effect="dark" placement="left">
            <div slot="content">
              全功能模式 - 开启<br>
              设置识别距离 1m<br>
              设置活体检测 - 开启<br>
              设置陌生人识别 - 开启<br>
              设置设备音量 - 50<br>
              设置可通行人员类型 - 已注册用户<br>
              设置识别后在线验证 - 开启<br>
              设置设备识别照片抓拍的质量 - 不上传<br>
              口罩检测 - 关闭<br>
              设置识别置信度<br>
              体温检测 - 仅提示<br>
              体温检测模式 - 初筛<br>
              初筛模式标准 - 宽松<br>
              低温可通行<br>
              设置设备体温检测距离 1m<br>
              停用广告<br>
            </div>
            <el-button type="text" @click="fnInitFaceDeviceEvent(row.value)">初始化设备</el-button>
          </el-tooltip>
          <el-button type="text" @click="fnRebootFaceDeviceEvent(row.value)">重启设备</el-button>
          <el-button type="text" @click="fnEditFaceDevice(row)">编辑</el-button>
          <el-button type="text" style="color:red!important" @click="fnDeleteFaceDevice(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :key="'main'+dialogScreenKey" append-to-body title="配置大屏" :visible.sync="bShowDeivceMangeDialog" width="400px">
      <FaceDeviceUpdate :key="'update'+dialogScreenKey" :item="currentFaceDevice" @successCBK="fnGetFaceDeviceList()" />
    </el-dialog>
  </div>

</template>
<script>
const defaultDeivcePostForm = {
  shopId: '',
  key: 'face_sn',
  value: '',
  id: ''
}
import FaceDeviceUpdate from './FaceDeviceUpdate'
export default {
  name: 'FaceDeviceMenuManage',
  components: {
    FaceDeviceUpdate
  },
  props: {
    shopId: {
      type: [String, Number],
      required: false,
      default: ''

    }
  },
  data() {
    return {
      selectList: [],
      lists: [],
      dialogScreenKey: 0,
      bShowDeivceMangeDialog: false,
      tableKey: 0,
      total: 0,
      currentFaceDevice: Object.assign({}, defaultDeivcePostForm),
      currentItem: {},
      listQuery: {
        shopId: '',
        key: 'face_sn'
      }
    }
  },
  created() {
    this.listQuery.shopId = this.shopId
    this.fnGetFaceDeviceList()
  },
  methods: {
    fnGetFaceDeviceList: function() {
      this.bShowDeivceMangeDialog = false
      this.$http.getShopValueList(this.listQuery).then(res => {
        this.tableKey++
        this.lists = res.data
      })
    },
    fnInitFaceDeviceEvent(sn) {
      if (!sn) {
        this.$message({
          type: 'error',
          message: '请先配置'
        })
      }
      this.$confirm(`是否确认初始化！${sn}`, '确认重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.fnInitFace(sn)
      })
    },
    fnRebootFaceDeviceEvent(sn) {
      if (!sn) {
        this.$message({
          type: 'error',
          message: '请先配置'
        })
      }
      this.$confirm(`是否重启设备！${sn}`, '确认重启', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.rebootDevice({ sn }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '重启成功'
            })
          }
        })
      })
    },
    fnInitFace(sn) {
      this.$http.initializeDevice({ sn }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '初始化成功'
          })
        }
      })
    },
    fnDeleteFaceDevice: function(id) {
      this.$confirm('确认删除人脸设备？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delShopValue({ id: id }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetFaceDeviceList()
        })
      }).catch(() => {

      })
    },
    fnAddDeivce: function() {
      this.currentFaceDevice = Object.assign({}, defaultDeivcePostForm)
      this.currentFaceDevice.shopId = this.listQuery.shopId
      this.dialogScreenKey += 1
      this.bShowDeivceMangeDialog = true
    },
    fnEditFaceDevice: function(FaceDevice) {
      this.currentFaceDevice = FaceDevice
      this.currentFaceDevice.shopId = this.currentFaceDevice.shop_id
      this.dialogScreenKey += 1
      this.bShowDeivceMangeDialog = true
    }
  }
}
</script>
<style lang="scss">
  .FaceDevice-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
